export default function Footer() {
  return (
    <footer className="footer">
      <div className="left" />
      <div className="right" />
    </footer>
  );
}
